var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoSlide',{attrs:{"src":require('@/assets/videos/SAF-400_Ares_SocialEngineering_2025.mp4'),"vtt":require('@/assets/videos/SAF-400_Ares_SocialEngineering_2025.vtt'),"background-color":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }